/**
 * Price thresholds for color coding in öre/kWh
 */
export const PRICE_THRESHOLDS = {
  LOW: 30,
  MEDIUM: 60,
  HIGH: 100,
} as const;

/**
 * Price color mapping based on thresholds
 */
export const PRICE_COLORS = {
  LOW: 'var(--green-11)',
  MEDIUM: 'var(--yellow-11)',
  HIGH: 'var(--orange-11)',
  VERY_HIGH: 'var(--red-11)',
} as const;
